import { render, staticRenderFns } from "./c_home_menu.vue?vue&type=template&id=ff67f90c&scoped=true"
import script from "./c_home_menu.vue?vue&type=script&lang=js"
export * from "./c_home_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff67f90c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff67f90c')) {
      api.createRecord('ff67f90c', component.options)
    } else {
      api.reload('ff67f90c', component.options)
    }
    module.hot.accept("./c_home_menu.vue?vue&type=template&id=ff67f90c&scoped=true", function () {
      api.rerender('ff67f90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_menu.vue"
export default component.exports